module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [(_vm.showCreatedAccountInfo) ? _c('div', {
    staticClass: "exclamation exclamation--green"
  }, [_c('span', {
    staticClass: "exclamation__text exclamation__text--green"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ACCOUNT_WAS_NOT_ACTIVATED_2')) + "\n            "), _c('router-link', {
    staticClass: "activation-code-link",
    attrs: {
      "to": "wyslij-kod-aktywacyjny"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('CLICK_HERE')) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.$t('TO_GENERATE_NEW_LINK')) + "\n        ")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-form-container"
  }, [_c('app-my-login-form'), _vm._v(" "), _c('app-my-registry-form', {
    on: {
      "accountCreated": function($event) {
        _vm.showCreatedAccountInfo = true
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-133413a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/auth/login-signin.vue
// module id = 1165
// module chunks = 0